// = require devex/search/searchJS

angular.module('devex.search', [])
  .factory('SearchJS', function() {
    return devex.search.SearchJS;
  });
